module.exports = __webpack_public_path__ + "img/Middle_school.18247439.svg";